import React, { useEffect, useState } from "react";
import axios from "axios";
import Style from "../Style/AdminView.module.scss";

const baseURL = process.env.REACT_APP_BASE_URL;

const AdminView = () => {
  const [images, setImages] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editImage, setEditImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`${baseURL}/api/images`);
      const imagesData = Array.isArray(res.data)
        ? res.data
        : res.data.images || [];
      setImages(imagesData);
    } catch (err) {
      console.error("Error fetching images:", err);
      setError("Failed to load images");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseURL}/api/delete/${id}`);
      fetchImages();
    } catch (err) {
      console.error("Error deleting image:", err);
      setError("Failed to delete image");
    }
  };

  const openEditModal = (img) => {
    setEditId(img.id);
    setEditImage(null);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (editImage) {
      formData.append("image", editImage);
    }

    try {
      await axios.put(`${baseURL}/api/update/${editId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setEditId(null);
      setEditImage(null);
      fetchImages();
    } catch (err) {
      console.error("Error updating image:", err);
      setError("Failed to update image");
    }
  };

  return (
    <div className={Style.adminView}>
      <h2 className={Style.heading}>Gallery View</h2>

      {error && <div className={Style.error}>{error}</div>}

      {loading ? (
        <div className={Style.loading}>Loading images...</div>
      ) : Array.isArray(images) && images.length > 0 ? (
        <div className={Style.galleryGrid}>
          {images.map((img) => (
            <div key={img.id} className={Style.card}>
              {editId === img.id ? (
                <form onSubmit={handleEditSubmit} className={Style.editForm}>
                  <input
                    type="file"
                    onChange={(e) => setEditImage(e.target.files[0])}
                  />
                  <div className={Style.buttonGroup}>
                    <button type="submit" className={Style.saveBtn}>
                      Save
                    </button>
                    <button
                      type="button"
                      onClick={() => setEditId(null)}
                      className={Style.cancelBtn}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              ) : (
                <>
                  <img
                    src={img.image_url}
                    alt="Uploaded"
                    className={Style.image}
                  />
                  <div className={Style.buttonGroup}>
                    <button
                      onClick={() => openEditModal(img)}
                      className={Style.editBtn}
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(img.id)}
                      className={Style.deleteBtn}
                    >
                      Delete
                    </button>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className={Style.noData}>No images found.</div>
      )}
    </div>
  );
};

export default AdminView;
